export const observeTogglingSlot = ({ rootEl, slotName, onAdd, onRemove }: { rootEl: HTMLElement; slotName: string; onAdd?: () => void; onRemove?: () => void }) => {
  let observerSlot;
  observerSlot = new MutationObserver(mutations => {
    for (let mutation of mutations) {
      if (mutation.type === 'childList') {
        // @ts-ignore
        const slotEl = mutation.target.querySelector?.(`[slot="${slotName}"]`);
        if (slotEl) {
          onAdd?.();
        } else {
          onRemove?.();
        }
      }
    }
  });

  observerSlot.observe(rootEl, { childList: true });
  return observerSlot;
};
